import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';
import ErrorBoundary from '../../../error-boundary';

class ParagraphAkkordionText extends Component {
  render() {
    const sectionClassNames = classNames({
      'paragraph paragraph-akkordion-text': true,
      'dark': this.props.content.fieldFarbigHinterlegen
    });

    return (
      <section className={sectionClassNames}>

        <div className="container">
          <div className="row">
            {!!this.props.content.fieldHeading &&
            <div className="col-12 heading">
              {this.props.content.fieldHeading}
            </div>
            }
            <div className="col-12">
              <ErrorBoundary><Accordion
                allowZeroExpanded={true}
                allowMultipleExpanded={false}
              >
                {this.props.content.fieldAbschnitte.map((item, index) =>
                  <AccordionItem key={index}>
                    <AccordionItemHeading>
                      <AccordionItemButton>
                        <div className="button-wrapper">
                          <span>{`${index+1}.`}</span>
                          {item.entity.fieldTitel}
                        </div>
                        <div className="toggle-icon">
                          {this.props.content.fieldFarbigHinterlegen &&
                          <img src="/themes/custom/module_box/src/images/Kalender-Button-Pfeil-links-white.svg" alt=""/>
                          }
                          {!this.props.content.fieldFarbigHinterlegen &&
                          <img src="/themes/custom/module_box/src/images/Kalender-Button-Pfeil-links.svg" alt=""/>
                          }
                        </div>
                      </AccordionItemButton>
                    </AccordionItemHeading>
                    <AccordionItemPanel>
                      <div className="text"
                           dangerouslySetInnerHTML={{__html: item.entity.fieldText.value}}/>
                    </AccordionItemPanel>
                  </AccordionItem>
                )}
              </Accordion></ErrorBoundary>
            </div>
          </div>
        </div>

      </section>
    );
  }
}

ParagraphAkkordionText.propTypes = {
  content: PropTypes.object.isRequired
};

export default ParagraphAkkordionText;
